import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { enGB } from "date-fns/locale";
import { getDay } from 'date-fns'
import { DateRangePicker, START_DATE, END_DATE } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import axios from "axios";
import "./style.css"
////
import { Link } from "react-router-dom";
import SignUpPopUp from "../../Common/Signup/Signup";
import LoginPopup from "../../Common/Login/Login";
import { useContext } from "react";
import { logOut } from "../../../authContext/apiCalls";
import { AuthContext } from "../../../authContext/AuthContext";
import { FiChevronDown, FiSearch, FiCalendar, FiMinus, FiPlus, FiMapPin, FiUsers } from "react-icons/fi";
import { IoMdLogOut } from "react-icons/io";
import { HiOutlinePhotograph } from "react-icons/hi";
import { BsGear } from "react-icons/bs";
import { FaBookmark, FaStar, FaWallet } from "react-icons/fa";
import { resolveGuests, setStoredGuests } from "../../../utils/guestSelection";
///
const citySuggestions = [
  { id: 1, name: "Lonavala" },
  { id: 2, name: "Goa" },
  { id: 3, name: "Alibag" },
  { id: 4, name: "Igatpuri" },
  { id: 5, name: "Mahabaleshwar" },
  { id: 6, name: "Panchgani" },
  { id: 7, name: "Nashik" },
  { id: 8, name: "Karjat" },
  { id: 9, name: "Udaipur" },
  { id: 10, name: "Manali" },
  { id: 11, name: "Jaipur" },
  { id: 12, name: "Pune" },
  { id: 13, name: "Dehradun" },
  { id: 14, name: "Khopoli" },
  { id: 15, name: "Mount Abu" },
  { id: 16, name: "Shimla" },
  { id: 17, name: "Ooty" },
  { id: 18, name: "Kanatal" },
  { id: 19, name: "Mussoorie" },
  { id: 20, name: "Kodaikanal" },
  { id: 21, name: "Dhanaulti" },
];

const MainSection = () => {
  ////
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { user, dispatch } = useContext(AuthContext);
  const handleLogout = () => {
    logOut(dispatch);
    setIsDropdownOpen(false);
    navigate.push("/");
  };
  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  /////
  const initialGuests = resolveGuests();
  const [adults, setAdults] = useState(initialGuests.adults);
  const [children, setChildren] = useState(initialGuests.children);
  const [infants, setInfants] = useState(initialGuests.infants);
  const [pets, setPets] = useState(initialGuests.pets);
  const [guestsOpen, setGuestsOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [location, setLocation] = useState("");
  const [cities, setCities] = useState([]);
  const [locationError, setLocationError] = useState(false);

  useEffect(() => {
    setStoredGuests({ adults, children, infants, pets });
  }, [adults, children, infants, pets]);

  const [Loginpop, SetLoginPop] = useState(false);
  const [Registerpop, SetRegisterpop] = useState(false);
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(min-width: 1024px)").matches
      : true
  );

  const handleAllCities = async () => {
    const res2 = await axios.get(
      `${process.env.REACT_APP_API_AWS}/getAllCities`
    );
    setCities(res2.data.data);
  };
  useEffect(() => {
    handleAllCities();
  }, []);

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const onChange = () => setIsDesktop(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const handleLocationChange = (e) => {
    let value = e.target.value;
    let matches = [];

    if (value.length >= 1) {
      const regex = new RegExp(`${value}`, "gi");
      matches = cities?.filter((item) => regex.test(item.name));
    }
    setSuggestions(matches);
    setLocation(value);
    if (value.trim()) setLocationError(false);
  };

  const handleSubmit = () => {
    const trimmed = (location || "").trim();
    if (!trimmed) {
      setLocationError(true);
      setClicked(true);
      setGuestsOpen(false);
      // retrigger animation if already shaking
      const el = document.querySelector(".location-field-validate");
      if (el) {
        el.classList.remove("location-shake");
        // force reflow
        // eslint-disable-next-line no-unused-expressions
        el.offsetWidth;
        el.classList.add("location-shake");
      }
      return;
    }

    setLocationError(false);
    const formData = {
      location: trimmed,
      startDate: startDate,
      endDate: endDate,
      adults: adults,
      children: children,
      infants: infants,
      pets: pets,
    };
    setStoredGuests({ adults, children, infants, pets });
    const hyphenlocation = trimmed.replace(/\s+/g, "-");
    navigate(`/search/${hyphenlocation}`, { state: formData });
  };

  const guestSummary = [
    `${adults} Adult${adults === 1 ? "" : "s"}`,
    children ? `${children} Child${children === 1 ? "" : "ren"}` : null,
    infants ? `${infants} Little one${infants === 1 ? "" : "s"}` : null,
    pets ? `${pets} Pet${pets === 1 ? "" : "s"}` : null,
  ]
    .filter(Boolean)
    .join(" · ");

  const Stepper = ({ label, hint, value, onMinus, onPlus, minusDisabled }) => (
    <div className="flex items-center justify-between gap-3 py-3.5">
      <div className="min-w-0">
        <div className="text-[16px] font-semibold text-[#222]">{label}</div>
        <div className="text-[13px] text-[#717171] mt-0.5">{hint}</div>
      </div>
      <div className="flex items-center gap-3 shrink-0">
        <button
          type="button"
          aria-label={`Decrease ${label}`}
          onClick={onMinus}
          disabled={minusDisabled}
          className={`w-9 h-9 rounded-full border border-[#B0B0B0] flex items-center justify-center ${
            minusDisabled
              ? "opacity-40 cursor-not-allowed"
              : "hover:border-[#222] hover:bg-gray-50"
          }`}
        >
          <FiMinus size={16} strokeWidth={2.5} />
        </button>
        <span className="w-6 text-center text-[16px] font-medium tabular-nums">
          {value}
        </span>
        <button
          type="button"
          aria-label={`Increase ${label}`}
          onClick={onPlus}
          className="w-9 h-9 rounded-full border border-[#B0B0B0] flex items-center justify-center hover:border-[#222] hover:bg-gray-50"
        >
          <FiPlus size={16} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );

  const [suggestion, setSuggestions] = useState([]);
  const [select, setSelect] = useState("");
  const [clicked, setClicked] = useState(false);

  const handleChange = (e) => {
    let value = e.target.value;
    let matches = [];

    if (value.length >= 1) {
      const regex = new RegExp(`${value}`, "gi");
      matches = cities?.filter((item) => regex.test(item.name));
    }
    setSuggestions(matches);
    setLocation(value);
    if (value.trim()) setLocationError(false);
  };

  const selectValue = (item) => {
    setSelect(item);
    setSuggestions("");
    setLocation(item);
    setLocationError(false);
  };
//   useEffect(() => {

//     //console.log(startDate,endDate,"asddsa");
// }, [startDate,endDate]);

const modifiers = {

  highlight: date => getDay(date) === 6 // Highlights Tuesdays
}
const modifiersClassNames = {
  highlight: '-highlight'
}
const customLocale = {
  ...enGB,
  options: {
    ...enGB.options,
    weekStartsOn: 0, // Set the week to start on Saturday
  }
};
  return (
    <div>
      {Loginpop && (
        <LoginPopup
          SetLoginPop={SetLoginPop}
          Loginpop={Loginpop}
          Registerpop={Registerpop}
          SetRegisterpop={SetRegisterpop}
        />
      )}
      {Registerpop && (
        <SignUpPopUp
          Registerpop={Registerpop}
          SetRegisterpop={SetRegisterpop}
          SetLoginPop={SetLoginPop}
          Loginpop={Loginpop}
        />
      )}
      <div className="font-jt flex mx-2 flex-row justify-between lg:hidden">
        <div className="h-[40px] flex justify-center  mt-1 w-[15%]">
        <Link to="/"> <img src="/a2z-logo.png" className="h-[60px] w-[60px] rounded-full object-cover" alt="A2Z Villaz" /></Link>
        </div>
        <div className="flex mt-3  justify-end flex-row">
          <a
            href="https://host.a2zvillaz.com/login/"
            target="_blank"
            rel="noopener noreferrer"
            className="mr-1 font-semibold text-[14px] underline my-auto hover:cursor-pointer"
          >
            Become a Host!
          </a>
          {user ? (
            <div className="flex flex-row items-center">
              <div className="rounded-full bg-white w-10 h-10 flex items-center justify-center mr-2">
                <img
                  width="34"
                  height="34"
                  src="./user.png"
                  alt="user-male-circle"
                />
              </div>
              <div onClick={handleDropdownToggle} className="text-xl -ml-1 font-bold" style={{ textTransform: "capitalize" }}>{user.first_name}</div>
              <button
                className="flex items-center focus:outline-none"
                onClick={handleDropdownToggle}
              >
                <FiChevronDown size={24} />
              </button>
              {isDropdownOpen && (
                <div className="absolute right-2 top-14 border-2 w-48 bg-white rounded-md shadow-lg py-2">
                  <Link
                    to="/profile"
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    <BsGear className="inline-block mr-2" size={16} />
                    Manage Account
                  </Link>
                  <a
                    href="#"
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    <FaBookmark className="inline-block mr-2" size={16} />
                    Bookings
                  </a>
                  <a
                    href="#"
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    <FaWallet className="inline-block mr-2" size={16} />
                    Rewards and Wallet
                  </a>
                  <a
                    href="#"
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    <FaStar className="inline-block mr-2" size={16} />
                    Reviews
                  </a>
                  <a
                    href="#"
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    <FaBookmark className="inline-block mr-2" size={16} />
                    Saved
                  </a>
                  <a
                    href="#"
                    className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    onClick={handleLogout}
                  >
                    <IoMdLogOut className="inline-block mr-2" size={16} />
                    Sign Out
                  </a>
                </div>
              )}
            </div>
          ) : (
            <>
              <button
                onClick={() => {
                  SetRegisterpop(!Registerpop);
                }}
                className="bg-white font-bold  text-black border-black border-2 w-[100px] h-[40px] rounded-full shadow-md"
              >
                Register
              </button>
              <button
                onClick={() => {
                  SetLoginPop(!Loginpop);
                }}
                className="bg-black font-bold   ml-2 text-white  w-[100px] h-[40px] rounded-full  shadow-md"
              >
                Sign in
              </button>
            </>
          )}
        </div>
      </div>
      <div className="font-jt">
        <div className="relative min-h-[92vh] lg:min-h-screen overflow-visible lg:overflow-visible rounded-[40px] lg:rounded-none mx-2 lg:mx-0 mt-10 lg:mt-0 mb-8">
          <div className="absolute inset-0">
            <img
              src="/lavish-villa.png"
              alt="Lavish villa"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/40 to-black/25" />
          </div>

          <div className="relative z-10 flex flex-col min-h-[92vh] lg:min-h-screen px-4 sm:px-6 lg:px-12 py-4 lg:py-6">
            <div className="hidden lg:flex justify-between items-center gap-4 mb-8">
              <Link to="/" className="shrink-0">
                <img
                  src="/a2z-logo.png"
                  alt="A2Z Villaz"
                  className="h-[64px] w-[64px] rounded-full object-cover shadow-lg ring-2 ring-white/40"
                />
              </Link>
              <div className="flex items-center gap-4">
              <a
                href="https://host.a2zvillaz.com/login/"
            target="_blank"
            rel="noopener noreferrer"
                className="font-semibold text-[15px] underline text-white hover:opacity-90"
              >
                Become a Host!
              </a>
              {user ? (
                <div className="flex flex-row items-center text-white">
                  <div className="rounded-full bg-white w-10 h-10 flex items-center justify-center mr-2">
                    <img width="34" height="34" src="./user.png" alt="user" />
                  </div>
                  <div
                    onClick={handleDropdownToggle}
                    className="text-xl -ml-1 font-bold"
                    style={{ textTransform: "capitalize" }}
                  >
                    {user.first_name}
                  </div>
                  <button
                    className="flex items-center focus:outline-none"
                    onClick={handleDropdownToggle}
                  >
                    <FiChevronDown size={24} />
                  </button>
                  {isDropdownOpen && (
                    <div className="absolute right-12 top-16 border-2 w-48 bg-white text-black rounded-md shadow-lg py-2">
                      <Link
                        to="/profile"
                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                      >
                        <BsGear className="inline-block mr-2" size={16} />
                        Manage Account
                      </Link>
                      <a
                        href="#"
                        className="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                        onClick={handleLogout}
                      >
                        <IoMdLogOut className="inline-block mr-2" size={16} />
                        Sign Out
                      </a>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <button
                    onClick={() => SetRegisterpop(!Registerpop)}
                    className="bg-white/95 font-bold text-black border-2 border-white w-[130px] h-[35px] rounded-full shadow-md"
                  >
                    Register
                  </button>
                  <button
                    onClick={() => SetLoginPop(!Loginpop)}
                    className="bg-black font-bold text-white w-[130px] h-[35px] rounded-full shadow-md"
                  >
                    Sign in
                  </button>
                </>
              )}
              </div>
            </div>

            <div className="flex-1 flex flex-col justify-end lg:justify-center items-center pb-6 lg:pb-10">
              <h1 className="text-white text-[32px] sm:text-[40px] lg:text-[52px] leading-tight tracking-wide font-bold mb-5 lg:mb-8 drop-shadow-lg text-center">
                Discover your{" "}
                <span className="decoration-2">
                  Dream Villaz
                </span>{" "}
                with us
              </h1>

              <div className="w-full lg:w-fit lg:max-w-[920px] mx-auto bg-white/95 backdrop-blur-md rounded-3xl shadow-2xl border border-white/40 p-3 sm:p-4 lg:p-3 relative overflow-visible">
                {/* Mobile location */}
                <div className="lg:hidden mb-3">
                  <div
                    className={`location-field-validate flex items-center gap-3 bg-[#F7F7F7] rounded-2xl px-4 py-3.5 border transition-colors ${
                      locationError
                        ? "border-red-500 location-shake bg-red-50"
                        : "border-[#EBEBEB]"
                    }`}
                  >
                    <FiMapPin
                      className={`shrink-0 ${locationError ? "text-red-500" : "text-[#222]"}`}
                      size={20}
                    />
                    <input
                      type="text"
                      placeholder="Where are you going?"
                      value={location}
                      onChange={handleLocationChange}
                      style={{ textTransform: "capitalize" }}
                      onClick={() => { setClicked(true); setGuestsOpen(false); }}
                      className="w-full text-[16px] font-medium bg-transparent border-transparent focus:border-transparent focus:ring-0 focus:outline-none"
                      aria-invalid={locationError}
                    />
                    <FiSearch
                      className={`shrink-0 ${locationError ? "text-red-500" : "text-[#222]"}`}
                      size={20}
                    />
                  </div>
                  {locationError ? (
                    <p className="mt-1.5 px-1 text-sm font-medium text-red-500">
                      Please select a location
                    </p>
                  ) : null}
                </div>

                {(suggestion?.length > 0 || clicked) && (
                  <div className="absolute z-40 bg-white left-3 right-3 lg:left-3 lg:right-auto lg:w-[320px] shadow-xl border border-[#E8E8E8] rounded-2xl overflow-hidden top-[4.8rem] lg:top-[4.6rem] max-h-[320px] overflow-y-auto">
                    {(suggestion?.length > 0 ? suggestion.slice(0, 20) : citySuggestions).map((item) => (
                      <div
                        key={item.id}
                        className="px-4 py-3 text-[16px] border-b border-[#EBEBEB] font-semibold cursor-pointer hover:bg-gray-50"
                        onClick={() => {
                          selectValue(item.name);
                          setClicked(false);
                        }}
                      >
                        {item.name}
                      </div>
                    ))}
                  </div>
                )}

                {/* Desktop strip */}
                {isDesktop && (
                <div className="hidden lg:flex items-stretch divide-x divide-[#EBEBEB] booking-strip">
                  <div
                    className={`location-field-validate flex w-[170px] xl:w-[190px] shrink-0 items-center gap-2 px-3 py-2 min-w-0 rounded-xl transition-colors ${
                      locationError
                        ? "location-shake ring-2 ring-red-500 bg-red-50"
                        : ""
                    }`}
                  >
                    <FiMapPin
                      className={`shrink-0 ${locationError ? "text-red-500" : "text-[#222]"}`}
                      size={18}
                    />
                    <div className="min-w-0 w-full">
                      <div
                        className={`text-[11px] font-semibold uppercase tracking-wide ${
                          locationError ? "text-red-500" : "text-[#717171]"
                        }`}
                      >
                        Location
                      </div>
                      <input
                        type="text"
                        placeholder="Search"
                        value={location}
                        onChange={handleLocationChange}
                        style={{ textTransform: "capitalize" }}
                        onClick={() => { setClicked(true); setGuestsOpen(false); }}
                        className="w-full text-[15px] font-semibold bg-transparent border-transparent focus:border-transparent focus:ring-0 focus:outline-none px-0"
                        aria-invalid={locationError}
                      />
                    </div>
                  </div>

                  <DateRangePicker
                    startDate={startDate}
                    endDate={endDate}
                    onStartDateChange={(d) => { setStartDate(d); setGuestsOpen(false); setClicked(false); }}
                    onEndDateChange={(d) => { setEndDate(d); setGuestsOpen(false); setClicked(false); }}
                    minimumDate={new Date()}
                    minimumLength={1}
                    format="dd MMM yyyy"
                    modifiersClassNames={modifiersClassNames}
                    modifiers={modifiers}
                    locale={customLocale}
                  >
                    {({ startDateInputProps, endDateInputProps, focus }) => (
                      <div
                        className="booking-dates"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          className="booking-checkin"
                          onMouseDown={(e) => {
                            if (e.target.tagName !== "INPUT") {
                              e.preventDefault();
                              e.currentTarget.querySelector("input")?.focus();
                            }
                          }}
                        >
                          <FiCalendar className="text-[#222] shrink-0" size={20} />
                          <div className="min-w-0 w-full">
                            <div className="text-[12px] font-semibold text-[#717171] uppercase tracking-wide">Check in</div>
                            <input
                              className={"w-full bg-transparent font-semibold text-[16px] border-transparent focus:border-transparent focus:ring-0 focus:outline-none px-0 cursor-pointer" + (focus === START_DATE ? " -focused" : "")}
                              {...startDateInputProps}
                              placeholder="Add date"
                              readOnly
                              onFocus={(e) => {
                                startDateInputProps.onFocus?.(e);
                                setGuestsOpen(false);
                                setClicked(false);
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                startDateInputProps.onFocus?.(e);
                                setGuestsOpen(false);
                                setClicked(false);
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className="booking-checkout"
                          onMouseDown={(e) => {
                            if (e.target.tagName !== "INPUT") {
                              e.preventDefault();
                              e.currentTarget.querySelector("input")?.focus();
                            }
                          }}
                        >
                          <FiCalendar className="text-[#222] shrink-0" size={20} />
                          <div className="min-w-0 w-full">
                            <div className="text-[12px] font-semibold text-[#717171] uppercase tracking-wide">Check out</div>
                            <input
                              className={"w-full bg-transparent font-semibold text-[16px] border-transparent focus:border-transparent focus:ring-0 focus:outline-none px-0 cursor-pointer" + (focus === END_DATE ? " -focused" : "")}
                              {...endDateInputProps}
                              placeholder="Add date"
                              readOnly
                              onFocus={(e) => {
                                endDateInputProps.onFocus?.(e);
                                setGuestsOpen(false);
                                setClicked(false);
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                endDateInputProps.onFocus?.(e);
                                setGuestsOpen(false);
                                setClicked(false);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </DateRangePicker>

                  <div className="relative flex-1 min-w-[180px] px-4 py-2 flex items-center">
                    <button
                      type="button"
                      onClick={() => { setGuestsOpen((v) => !v); setClicked(false); }}
                      className="w-full flex items-center gap-3 text-left"
                    >
                      <FiUsers className="text-[#222] shrink-0" size={20} />
                      <div className="min-w-0 flex-1">
                        <div className="text-[12px] font-semibold text-[#717171] uppercase tracking-wide">Guests</div>
                        <div className="text-[15px] font-semibold text-[#222] truncate">{guestSummary}</div>
                      </div>
                      <FiChevronDown className={`shrink-0 transition-transform ${guestsOpen ? "rotate-180" : ""}`} size={18} />
                    </button>
                    {guestsOpen && (
                      <div className="absolute z-40 right-0 top-[calc(100%+10px)] w-[360px] bg-white rounded-2xl shadow-2xl border border-[#E8E8E8] p-4 divide-y divide-[#EBEBEB]">
                        <Stepper
                          label="Adults"
                          hint="Ages 13 or above"
                          value={adults}
                          onMinus={() => { if (adults > 1) setAdults(adults - 1); }}
                          onPlus={() => setAdults(adults + 1)}
                          minusDisabled={adults <= 1}
                        />
                        <Stepper
                          label="Children"
                          hint="Ages 6–12"
                          value={children}
                          onMinus={() => { if (children > 0) setChildren(children - 1); }}
                          onPlus={() => setChildren(children + 1)}
                          minusDisabled={children <= 0}
                        />
                        <Stepper
                          label="Little ones"
                          hint="0–5 years"
                          value={infants}
                          onMinus={() => { if (infants > 0) setInfants(infants - 1); }}
                          onPlus={() => { if (infants < 25) setInfants(infants + 1); }}
                          minusDisabled={infants <= 0}
                        />
                        <Stepper
                          label="Pets"
                          hint="Bringing a service animal?"
                          value={pets}
                          onMinus={() => { if (pets > 0) setPets(pets - 1); }}
                          onPlus={() => { if (pets < 5) setPets(pets + 1); }}
                          minusDisabled={pets <= 0}
                        />
                      </div>
                    )}
                  </div>

                  <div className="pl-3 pr-1 flex items-center">
                    <button
                      className="whitespace-nowrap px-7 py-3.5 font-bold text-lg rounded-2xl bg-black text-white shadow-md hover:bg-[#111] transition-colors"
                      onClick={handleSubmit}
                    >
                      Find Villaz
                    </button>
                  </div>
                </div>
                )}

                {/* Mobile stacked layout — only mounted below lg so it can't steal calendar focus */}
                {!isDesktop && (
                <div className="lg:hidden space-y-3">
                  <div className="booking-mobile">
                  <DateRangePicker
                    startDate={startDate}
                    endDate={endDate}
                    onStartDateChange={setStartDate}
                    onEndDateChange={setEndDate}
                    minimumDate={new Date()}
                    minimumLength={1}
                    format="dd MMM yyyy"
                    modifiersClassNames={modifiersClassNames}
                    modifiers={modifiers}
                    locale={customLocale}
                  >
                    {({ startDateInputProps, endDateInputProps, focus }) => (
                      <div
                        className="booking-dates booking-dates-mobile"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          className="booking-checkin"
                          onMouseDown={(e) => {
                            if (e.target.tagName !== "INPUT") {
                              e.preventDefault();
                              e.currentTarget.querySelector("input")?.focus();
                            }
                          }}
                        >
                          <div className="flex items-center gap-2 mb-1">
                            <FiCalendar size={16} />
                            <span className="text-[12px] font-semibold text-[#717171] uppercase">Check in</span>
                          </div>
                          <input
                            className={"w-full bg-transparent font-semibold text-[15px] border-transparent focus:border-transparent focus:ring-0 focus:outline-none px-0 cursor-pointer" + (focus === START_DATE ? " -focused" : "")}
                            {...startDateInputProps}
                            placeholder="Add date"
                            readOnly
                            onClick={(e) => {
                              e.stopPropagation();
                              startDateInputProps.onFocus?.(e);
                            }}
                          />
                        </div>
                        <div
                          className="booking-checkout"
                          onMouseDown={(e) => {
                            if (e.target.tagName !== "INPUT") {
                              e.preventDefault();
                              e.currentTarget.querySelector("input")?.focus();
                            }
                          }}
                        >
                          <div className="flex items-center gap-2 mb-1">
                            <FiCalendar size={16} />
                            <span className="text-[12px] font-semibold text-[#717171] uppercase">Check out</span>
                          </div>
                          <input
                            className={"w-full bg-transparent font-semibold text-[15px] border-transparent focus:border-transparent focus:ring-0 focus:outline-none px-0 cursor-pointer" + (focus === END_DATE ? " -focused" : "")}
                            {...endDateInputProps}
                            placeholder="Add date"
                            readOnly
                            onClick={(e) => {
                              e.stopPropagation();
                              endDateInputProps.onFocus?.(e);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </DateRangePicker>
                  </div>

                  <div className="bg-[#F7F7F7] border border-[#EBEBEB] rounded-2xl overflow-hidden">
                    <button
                      type="button"
                      onClick={() => setGuestsOpen((v) => !v)}
                      className="w-full flex items-center justify-between gap-3 px-4 py-3.5 text-left"
                    >
                      <div className="flex items-center gap-3 min-w-0">
                        <FiUsers size={20} className="shrink-0" />
                        <div className="min-w-0">
                          <div className="text-[12px] font-semibold text-[#717171] uppercase">Guests</div>
                          <div className="text-[15px] font-semibold text-[#222] truncate">{guestSummary}</div>
                        </div>
                      </div>
                      <FiChevronDown className={`shrink-0 transition-transform ${guestsOpen ? "rotate-180" : ""}`} size={18} />
                    </button>
                    {guestsOpen && (
                      <div className="px-4 pb-2 border-t border-[#EBEBEB] bg-white divide-y divide-[#EBEBEB]">
                        <Stepper
                          label="Adults"
                          hint="Ages 13 or above"
                          value={adults}
                          onMinus={() => { if (adults > 1) setAdults(adults - 1); }}
                          onPlus={() => setAdults(adults + 1)}
                          minusDisabled={adults <= 1}
                        />
                        <Stepper
                          label="Children"
                          hint="Ages 6–12"
                          value={children}
                          onMinus={() => { if (children > 0) setChildren(children - 1); }}
                          onPlus={() => setChildren(children + 1)}
                          minusDisabled={children <= 0}
                        />
                        <Stepper
                          label="Little ones"
                          hint="0–5 years"
                          value={infants}
                          onMinus={() => { if (infants > 0) setInfants(infants - 1); }}
                          onPlus={() => { if (infants < 25) setInfants(infants + 1); }}
                          minusDisabled={infants <= 0}
                        />
                        <Stepper
                          label="Pets"
                          hint="Bringing a service animal?"
                          value={pets}
                          onMinus={() => { if (pets > 0) setPets(pets - 1); }}
                          onPlus={() => { if (pets < 5) setPets(pets + 1); }}
                          minusDisabled={pets <= 0}
                        />
                      </div>
                    )}
                  </div>

                  <button
                    className="w-full py-3.5 font-bold text-xl rounded-2xl bg-black text-white shadow-md"
                    onClick={handleSubmit}
                  >
                    Find Villaz
                  </button>
                </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainSection;
